"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PresentationIcon = function PresentationIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "14px", height: "14px", viewBox: "0 0 14 14" },
    _react2.default.createElement(
      "g",
      { fillRule: "evenodd" },
      _react2.default.createElement("path", { d: "M14,1 L14,12 L0,12 L0,1 L14,1 Z M1,2 L13,2 L13,11 L1,11 L1,2 Z M6,6 L12,6 L12,7 L6,7 L6,6 Z M6,8 L10,8 L10,9 L6,9 L6,8 Z M6,4 L12,4 L12,5 L6,5 L6,4 Z M3.5,7 C4.32842712,7 5,6.32842712 5,5.5 C5,4.67157288 4.32842712,4 3.5,4 C2.67157288,4 2,4.67157288 2,5.5 C2,6.32842712 2.67157288,7 3.5,7 Z" })
    )
  );
};

exports.default = PresentationIcon;